import { checkIfCarouselIsRecAi } from "~/userAnalytics";

export const getCarouselProps = (
  addToCartButtonOnCarousel: HTMLElement | null,
) => {
  // type checking since we are using refs to pass the element
  if (!addToCartButtonOnCarousel) {
    return {
      carouselName: "",
      carouselModel: "",
      position: 0,
      carouselPlacementId: undefined,
      shouldSetInteraction: undefined,
    };
  }
  // The old tracking system uses gtm-carousel-name, the new one uses data-, #1231122 will consolidate them
  let carouselElement = addToCartButtonOnCarousel?.closest(
    "[gtm-carousel-name]",
  );
  let carouselName = carouselElement?.getAttribute("gtm-carousel-name");

  if (!carouselElement) {
    carouselElement = addToCartButtonOnCarousel?.closest(
      "[data-gtm-carousel-name]",
    );
    carouselName = carouselElement?.getAttribute("data-gtm-carousel-name");
  }
  const addToCartButtons = carouselElement?.querySelectorAll(
    "[name=addToCartButton]",
  );
  if (!carouselName || !addToCartButtons) {
    return {
      carouselName: "",
      carouselModel: "",
      position: 0,
      carouselPlacementId: undefined,
      shouldSetInteraction: undefined,
    };
  }
  const position =
    Array.from(addToCartButtons).indexOf(addToCartButtonOnCarousel) + 1;

  return {
    carouselName,
    carouselModel: checkIfCarouselIsRecAi(carouselName),
    position,
    carouselPlacementId:
      carouselElement?.getAttribute("data-gtm-placement-id") ?? undefined,
    shouldSetInteraction:
      carouselElement?.hasAttribute("data-gtm-set-carousel-interaction") ??
      undefined,
  };
};
